module.exports = __webpack_public_path__ + "img/IMG_0033.7f1f35d9.png";